<template>
  <v-dialog
    v-model="show"
    max-width="490px"
  >
    <v-card>
      <v-expansion-panels v-model="panel">
          <v-expansion-panel>
            <v-expansion-panel-header class="ml-0 pl-4">{{ fileClass }} upload</v-expansion-panel-header>
            <v-expansion-panel-content>
              Please, upload {{ fileClass ? fileClass.toLowerCase() : '' }} and other document after which your request will be considered by one of company's accountats.
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      <v-card-text>
        <v-file-input
          label="Document"
          v-model="file.file"
          @change="onFileChange"
          accept="application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          :rules="[filesHaveDifferentNames||'Please, don\'t send 2 identical files']"
        ></v-file-input>
        <br />
        <v-row>
          <v-btn small outlined color="primary" @click="show = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" :disabled="!file.file" @click="postFile">Upload</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      panel: 0,
      file: {
        file: null,
        File_Name: '',
        File_Type: ''
      }
    }
  },
  name: 'FileInputDialog',
  props: {
    value: {
      required: true,
      default: false
    },
    request: {
      required: true,
      default: null
    },
    fileClass: {
      required: true,
      default: null
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        return this.value
      },
      set (value) {
        if (!value) {
          this.file = {
            file: null,
            File_Name: '',
            File_Type: ''
          }
        }
        this.$emit('input', value)
      }
    },
    filesHaveDifferentNames () {
      if (!this.request.Agreement_File_Name && !this.request.Confirmation_File_Name) {
        return true
      }
      return (this.request.Agreement_File_Name !== this.file.File_Name) &&
             (this.request.Confirmation_File_Name !== this.file.File_Name)
    }
  },
  methods: {
    onFileChange (e) {
      if (e) {
        const reader = new FileReader()
        reader.onload = () => {
          this.file.file.data = reader.result
          let binary = ''
          const bytes = new Uint8Array(this.file.file.data)
          const len = bytes.byteLength
          for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i])
          }
          this.file.file.base64String = `data:${e.type};base64, ${window.btoa(binary)}`
        }
        this.file.File_Name = e.name
        this.file.File_Type = e.type
        reader.readAsArrayBuffer(e)
      }
    },
    postFile () {
      this.axios.post('/api/requests/l_and_d_file', {
        File: this.file,
        FileClass: this.fileClass,
        Request_ID: this.request.Request_ID,
        Creator_ID: this.request.Creator_ID
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'File was uploaded' })
        this.$emit('updateFileInfo')
        this.show = false
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error })
      })
    }
  }
}
</script>
